import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";

class MonthlYardPrintReport extends Component {
  render() {
    const { transactions } = this.props;
    return (
      <Table celled fixed singleLine style={{ width: "100%" }}>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="6" style={{ textAlign:"center" }}>Yard Monthly Report</Table.HeaderCell>
        </Table.Row>

          <Table.Row>
            <Table.HeaderCell width={2}>Name</Table.HeaderCell>
            <Table.HeaderCell width={2}>Mobile</Table.HeaderCell>
            <Table.HeaderCell width={2}>Rent</Table.HeaderCell>
            <Table.HeaderCell width={4}>Company</Table.HeaderCell>
            <Table.HeaderCell width={2}>Closing Balance</Table.HeaderCell>
            {/* <Table.HeaderCell width={2}>Closing Balance</Table.HeaderCell> */}
            <Table.HeaderCell width={2}>Receive</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {transactions.map(transaction => (
            <React.Fragment>
              <Table.Row>
                <Table.Cell>{transaction.name}</Table.Cell>
                <Table.Cell>{transaction.mobile}</Table.Cell>
                <Table.Cell>{transaction.rent}</Table.Cell>
                <Table.Cell>{transaction.company}</Table.Cell>

                <Table.Cell>{transaction.balance}</Table.Cell>
                <Table.Cell></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell colSpan="6" style={{ backgroundColor: "#ddd" }}>
                  <Table celled fixed singleLine>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell width={9}>
                          Description
                        </Table.HeaderCell>
                        <Table.HeaderCell width={2}>
                          Payment Date
                        </Table.HeaderCell>
                        <Table.HeaderCell width={2}>Amount</Table.HeaderCell>
                        <Table.HeaderCell width={3}>Type</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {transaction.detail.map(row => (
                        <Table.Row>
                          <Table.Cell>{row.description}</Table.Cell>
                          <Table.Cell>{row.payment_date}</Table.Cell>
                          <Table.Cell>{row.payment}</Table.Cell>
                          <Table.Cell>{row.yard_ledger_type.name}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            </React.Fragment>
          ))}
        </Table.Body>
      </Table>
    );
  }
}
export default MonthlYardPrintReport;
